import {
  IonButton,
  IonCol,
  IonGrid,
  IonHeader,
  IonModal,
  IonRow,
  IonSpinner,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { FC } from "react";
import { OrderPriceDetails } from "./OrderPriceDetails";
import { ICart } from "../../models";
import { Flex } from "../../components/Flex/Flex";
import InfoMessage from "../../components/InfoMessage/InfoMessage";
import { useCommon } from "../../common/useCommon";
import { BIH_PRICE_MESSAGE } from "../../common/constants";

const Row: FC<{ label: string; value?: string }> = ({ label, value }) => (
  <IonRow>
    <IonCol
      style={{
        textAlign: "right",
        color: "var(--ion-color-dark-shade)",
      }}
    >
      <span style={{ lineHeight: "25px" }}>{label}</span>
    </IonCol>
    <IonCol className="b vertical-center">
      <span style={{ lineHeight: "25px" }}>{value}</span>
    </IonCol>
  </IonRow>
);

interface Props {
  isOpen: boolean;
  cart: ICart;
  onCancel: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
}

export const OrderConfirmation: FC<Props> = ({
  isOpen,
  cart,
  onCancel,
  onSubmit,
  isSubmitting,
}) => {
  const { currency } = useCommon();
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onCancel}>
      <IonHeader>
        <IonToolbar color="success">
          <IonTitle>Potvrda porudžbine</IonTitle>
        </IonToolbar>
      </IonHeader>
      <div style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
        <IonGrid style={{ width: "100%" }}>
          <Row label="Ime i prezime" value={cart.name} />
          <Row label="Adresa" value={cart.address} />
          <Row label="Poš. br. i mesto" value={`${cart.zip} ${cart.place}`} />
          <Row label="Telefon" value={cart.phone} />
          <Row label="e-mail" value={cart.email} />
          <Row label="Napomena" value={cart.note} />
        </IonGrid>
        <OrderPriceDetails />
        <div
          style={{
            padding: "3px 10px 8px",
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <InfoMessage
            text={
              <>
                Molimo Vas da još jednom proverite da li ste ispravno upisali
                broj telefona.
                <br />
                <b>{cart.phone}</b>
              </>
            }
            level="warning"
          />
          {currency === "KM" && (
            <InfoMessage text={BIH_PRICE_MESSAGE} level="warning" />
          )}
        </div>
        <Flex css={{ padding: "0 10px", marginBottom: "8px" }}>
          <IonButton
            color="light"
            onClick={onCancel}
            style={{ flexGrow: 0 }}
            disabled={isSubmitting}
          >
            Vrati se nazad
          </IonButton>
          <IonButton
            color="primary"
            onClick={onSubmit}
            style={{ flexGrow: 1 }}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <IonSpinner name="crescent" style={{ width: 21, height: 21 }} />
            ) : (
              <>NARUČI</>
            )}
          </IonButton>
        </Flex>
      </div>
    </IonModal>
  );
};
